<template lang="pug">
.uk-panel.uk-panel-box
    #certificates-tile-link.tile-link
    h3.uk-panel-title
        i.uk-icon-book
        span(data-include-text='добавлены', data-exclude-text='исключены') Сертификаты и декларации
    #certificates-tile--content(ref="print")
        table.uk-table(v-if="certificates")
            thead
                tr
                    th.left(width='1%') Тип
                    th Действующие
                    th Оконченные и аннулированные
                    th(width='1%') Всего
            tbody
                tr
                    td.left(width='1%') Сертификаты
                    td
                        span(
                        :class="{'uk-pseudolink': certificates.cert.active > 0}"
                        :data-uk-modal="(certificates.cert.active ? `{target: '#certificates-modal'}` : ``)"
                        @click="changeType('cert','active', certificates.cert.active)")
                            | {{certificates.cert.active}}
                    td
                        span(
                        :class="{'uk-pseudolink': certificates.cert.inactive > 0}"
                        :data-uk-modal="(certificates.cert.inactive ? `{target: '#certificates-modal'}` : ``)"
                        @click="changeType('cert','inactive', certificates.cert.inactive)")
                            | {{certificates.cert.inactive}}
                    td(width='1%')
                        span(
                        :class="{'uk-pseudolink': certificates.cert.total > 0}"
                        :data-uk-modal="(certificates.cert.total ? `{target: '#certificates-modal'}` : ``)"
                        @click="changeType('cert','all', certificates.cert.total)")
                            | {{certificates.cert.total}}
                tr
                    td.left(width='1%') Декларации
                    td
                        span(
                        :class="{'uk-pseudolink': certificates.decl.active > 0}"
                        :data-uk-modal="(certificates.decl.active ? `{target: '#certificates-modal'}` : ``)"
                        @click="changeType('decl','active', certificates.decl.active)")
                            | {{certificates.decl.active}}
                    td
                        span(
                        :class="{'uk-pseudolink': certificates.decl.inactive > 0}"
                        :data-uk-modal="(certificates.decl.inactive ? `{target: '#certificates-modal'}` : ``)"
                        @click="changeType('decl','inactive', certificates.decl.inactive)")
                            | {{certificates.decl.inactive}}
                    td(width='1%')
                        span(
                        :class="{'uk-pseudolink': certificates.decl.total > 0}"
                        :data-uk-modal="(certificates.decl.total ? `{target: '#certificates-modal'}` : ``)"
                        @click="changeType('decl','all', certificates.decl.total)")
                            | {{certificates.decl.total}}
            tfoot
                tr
                    td.left(width='1%') Всего
                    td
                        span(
                        :class="{'uk-pseudolink': certificates.total.active > 0}"
                        :data-uk-modal="certificates.total.active ? `{target: '#certificates-modal'}`: ``"
                        @click="changeType('all','active', certificates.total.active)")
                            | {{certificates.total.active}}
                    td
                        span(
                        :class="{'uk-pseudolink': certificates.total.inactive > 0}"
                        :data-uk-modal="(certificates.total.inactive ? `{target: '#certificates-modal'}` : ``)"
                        @click="changeType('all','inactive', certificates.total.inactive)")
                            | {{certificates.total.inactive}}
                    td(width='1%')
                        span(
                        :class="{'uk-pseudolink': certificates.total.total > 0}"
                        :data-uk-modal="(certificates.total.total ? `{target: '#certificates-modal'}` : ``)"
                        @click="changeType('all','all', certificates.total.total)")
                            | {{certificates.total.total}}
        .btns-holder
            tilePrintPdf(
                :html="printContent.html"
                :title="printContent.title"
                :filename="printContent.filename"
                :printStyle="printContent.style"
            )
    modal
</template>

<script>
import Modal from "./certificates_modal.vue";
import tilePrintPdf from '@/components/ui/tilePrintPdf/tilePrintPdf.vue'
import { Base64, htmlStringToPrint } from '@/helpers.ts'

export default {
    components: {
        modal: Modal,
        tilePrintPdf
    },
    computed: {
        auth() { return this.$store.state.auth; },
        certificates() { return this.$store.state.card?.certificates?.tile; },
    },
    data() {
        return {
            showFullScreen: false,
            showLegend: false,
            isModalOpen: false,
            data: null,
            printContent: {
                title: `Сертификаты и декларации | ${window.company.title}`,
                filename: 'Certificates-' + window.company.ogrn,
                html: null,
                style: `
                     table {
                        margin: 0 auto;
                        font-family: "Lucida Sans Unicode", "Lucida Grande", Sans-Serif;
                        font-size: 14px;
                        text-align: center;
                        border-collapse: collapse;
                    }
                    tfoot tr td { font-size: 14px; font-weight: bold; }
                    table td, table th { border: 1px solid #000 !important; text-align: center !important; width: 25% !important; }
                    th, td.left { color: inherit; padding: 10px 20px; }
                    td { padding: 10px 20px; background: #fff; text-align: center; }
                    table th { background: #ddd !important; }
                    #print-pdf-hint { display: none; }
                    .print-main-title { text-align: center; color: #4b6365; border-bottom: 1px solid #4b6365; font-weight: 600; }
                `
            },
            saveLoading: false
        }
    },
    methods: {
        changeType(type, status, total_amount) {
            this.$store.dispatch('card/certificates/changeType', { type, status, total_amount })
        },
        getData() {
            $('#tiles').trigger('resize')
            this.$store.dispatch("card/certificates/getStat")
                .finally(() => {
                    if(this.certificates?.total?.total) {
                        this.printContent.html = this.$refs.print.innerHTML
                        $('#tiles').trigger('resize')
                    } else {
                        $('#certificates-tile').hide()
                        $('#tiles').trigger('resize')
                        sidebar.iconActivator()
                    }
                })
        }
    },
    mounted() { this.getData() }
}
</script>

<style scoped>
.btns-holder {
    display: flex;
    justify-content: flex-end;
}
h3.uk-panel-title i {
    margin-right: 5px;
}
td, th.left {
    text-align: left;
}
td, th {
    text-align: center;
}
tfoot td {
    font-weight: bold;
}
</style>

<style>
.tile-link {
    margin-top:-110px;
    float:left;
}
</style>
